import React, { forwardRef } from 'react';
import SignatureCanvas from 'react-signature-canvas'
import AutoSizer from 'react-virtualized/dist/commonjs/AutoSizer';

const Signature = forwardRef((props, ref) => {
  return (
    <AutoSizer>
      {({ height, width }) => {
        return (
          <SignatureCanvas ref={ref} canvasProps={{ width, height, className: 'rounded border-2 border-gray-300' }} {...props}/>
        )
      }}
    </AutoSizer>
  )
})

export default Signature;